import { gql } from '@apollo/client'

// Driver status flow, gated on `delivery.drive` server-side. An order enters IN_DELIVERY
// only by its route being started (startDeliveryRun, graphql/delivery-run.ts) — never by a
// status change: the API rejects updateOrderStatus(id, IN_DELIVERY) for everyone ("Orders
// go out for delivery by starting their route, not by a status change"). claimDelivery and
// releaseDelivery were removed from the API on 2026-10-08 along with their documents here.
// Each mutation returns the updated Order so the normalized cache updates the card in
// place — no refetch on the happy path.
//
// The legacy claim-race prefix (CLAIM_CONFLICT_PREFIX, lib/delivery.ts) is still skipped by
// the global errorLink for an old client build; nothing here produces it any more.

// The selection DriverPage feeds straight into the status-override shield, which needs
// status + current_status_since + delivered_by_user TOGETHER (the delivered_by_user stamp
// is set by the route start and must survive the completion). Kept as a fragment so a
// future driver mutation reuses it rather than drifting.
const DRIVER_ORDER_FIELDS = gql`
  fragment DriverOrderFields on Order {
    id
    status
    current_status_since
    delivered_by_user {
      id
      name
    }
  }
`

// IN_DELIVERY → COMPLETED. Only the route's driver; the driver stamp survives.
export const MARK_DELIVERED = gql`
  mutation MarkDelivered($id: Int!) {
    markDelivered(id: $id) {
      ...DriverOrderFields
    }
  }
  ${DRIVER_ORDER_FIELDS}
`
